<div class="maintenance-settings" *transloco="let t; prefix: 'assetSettings'">
  <!-- Header Section -->
  <div class="maintenance-settings__header">
    <div class="maintenance-settings__title-section">
      <div class="title-with-back">
        <app-back-button></app-back-button>
        <h1>{{ t('maintenance.title') }}</h1>
      </div>
      <p>{{ t('maintenance.description') }}</p>
    </div>
  </div>

  <!-- Tabs Section -->
  <div class="tabs-container w-100">
    <button class="tab-button"
      [class.active]="isTabActive(maintenanceSettingsTab.MaintenanceConfiguration)"
      (click)="onTabChange(maintenanceSettingsTab.MaintenanceConfiguration)">
      {{ t('maintenance.tabs.configuration') }}
    </button>
    <button class="tab-button"
      [class.active]="isTabActive(maintenanceSettingsTab.Workshops)"
      (click)="onTabChange(maintenanceSettingsTab.Workshops)">
      {{ t('maintenance.tabs.workshops') }}
    </button>
  </div>

  <!-- Toolbar — Workshops tab only -->
  @if (isTabActive(maintenanceSettingsTab.Workshops)) {
    <div class="maintenance-settings__toolbar">
      <app-search [placeholder]="t('maintenance.searchWorkshopsPlaceholder')" [customWidth]="'389px'"
        (searchTermUpdated)="onWorkshopSearch($event)"></app-search>
      <div class="maintenance-settings__toolbar-right">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
        <button class="btn btn-danger add-workshop-btn" (click)="onAddWorkshop()">{{ t('maintenance.addWorkshop') }}</button>
      </div>
    </div>
  }

  <!-- Content Section -->
  @if (isTabActive(maintenanceSettingsTab.MaintenanceConfiguration)) {
    <app-maintenance-configuration></app-maintenance-configuration>
  }

  @if (isTabActive(maintenanceSettingsTab.Workshops)) {
    <app-add-workshops
      [searchTerm]="workshopSearchTerm"
      [accountFilter]="accountFilter"
      #workshopsRef>
    </app-add-workshops>
  }
</div>